import React from 'react'
import getCatalogName from '@/helpers/getCatalogName'
import TecdocMainCategories from '@/pages/tecdoc/mainCategories'

const ManagementCatalog = () => {

    const catalogName = getCatalogName()



    return (
        <div>
            <TecdocMainCategories />
        </div>
    )
}

export default ManagementCatalog